// extracted by mini-css-extract-plugin
export default {"suspendedAlert":"LockAvailabilityContent_suspendedAlert__dTEoA","sections":"LockAvailabilityContent_sections__yYfxy","section":"LockAvailabilityContent_section__GYHwp"};